// import Swal from 'sweetalert2';
// import 'sweetalert2/src/sweetalert2.scss';

// export const showCustomAlert = ({ title, text, icon, confirmButtonText, callback }) => {
//   Swal.fire({
//     title: title || 'Alert',
//     text: text || 'This is a custom alert.',
//     icon: icon || 'info',
//     confirmButtonText: confirmButtonText || 'OK',
//     showClass: {
//       popup: 'animate__animated animate__fadeInUp animate__faster',
//     },
//     hideClass: {
//       popup: 'animate__animated animate__fadeOutDown animate__faster',
//     },
//   }).then((result) => {
//     if (result.isConfirmed && callback) {f//       callback(); // Execute callback if provided
//     }
//   });
// };

import { logDOM } from "@testing-library/react";
import Swal from "sweetalert2";
import "sweetalert2/src/sweetalert2.scss";

export const showCustomAlert = ({
  title,
  text,
  icon,
  confirmButtonText,
  cancelButtonText,
  confirmButtonColor = "#3085d6",
  cancelButtonColor = "#d33",
  callback,
  setLoading = () => {},
}) => {
  Swal.fire({
    title: "Are you sure?",
    text: text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: confirmButtonColor,
    allowOutsideClick: false,
    allowEscapeKey: false,
    cancelButtonColor: cancelButtonColor,
    confirmButtonText: confirmButtonText || "Yes",
    cancelButtonText: cancelButtonText || "Cancel",
    showClass: {
      popup: "animate__animated animate__fadeInUp animate__faster",
    },
    hideClass: {
      popup: "animate__animated animate__fadeOutDown animate__faster",
    },
  }).then((result) => {
    if (result.isConfirmed) {
      console.log("isConfirmed", result.isConfirmed, callback);

      // Execute callback if confirmed
      if (callback) {
        callback();
      }

      // Show success message after confirming
      Swal.fire({
        title: title,
        // text: text,
        icon: icon,
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonText: "OK",
        confirmButtonColor: "#3085d6",
        showClass: {
          popup: "animate__animated animate__fadeInUp animate__faster",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutDown animate__faster",
        },
      });
    } else {
      setLoading(false);
    }
  });
};
